import axios from "axios";
import { ERROR, TIMEOUT } from "../routes/path";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  responseType: "json",
  timeout: 20000,
});
const instance2 = axios.create({
  baseURL: process.env.REACT_APP_API2_BASE_URL,
  responseType: "json",
  timeout: 20000,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === "ECONNABORTED") {
      window.location.href = TIMEOUT;
    } else {
      window.location.href = ERROR;
    }
  }
);
instance2.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === "ECONNABORTED") {
      window.location.href = TIMEOUT;
    } else {
      window.location.href = ERROR;
    }
  }
);

// 処方箋利用者情報取得
export const getCustomerInfo = (data) => {
  return instance.get("/getCustomerInfo", {
    params: data,
  });
};
// システム定数マスタ取得API
export const getSystemConstants = (data) => {
  return instance.get("/getPharmacySystemConstants", {
    params: data,
  });
};
// 処方箋問診質問取得API
export const getMedicalQuestionnaire = (data) => {
  return instance.get("/pharmacyQuestions", {
    params: data,
  });
};
// 処方箋会計情報取得API
export const getPaymentInformation = (data) => {
  return instance.get("/paymentInformation", {
    params: data,
  });
};
// 処方箋利用履歴取得API
export const getPrescriptionHistory = (data) => {
  return instance.get("/prescriptionHistory", {
    params: data,
  });
};
// 処方箋利用者情報登録
export const saveCustomerInfo = (data) => {
  return instance.post("/customerCreator", data);
};
// 処方箋利用者情報更新
export const updateCustomerInfo = (data) => {
  return instance.post("/customerUpdater", data);
};
// 処方箋利用者家族情報登録
export const setFamilyInformation = (data) => {
  return instance.post("/familyInformation", data);
};
// 薬局検索API
export const getPharmacy = (data) => {
  return instance.get("/getPharmacy", {
    params: data,
  });
};
// 薬局詳細情報取得API
export const getPharmacyInformation = (data) => {
  return instance.get("/getPharmacyInformation", {
    params: data,
  });
};
// 特定商取引法に基づく表記取得API
export const getSpecifiedCommercial = (data) => {
  return instance.get("/getSpecifiedCommercial", {
    params: data,
  });
};
// 処方箋申込登録
export const prescriptionRegistration = (data) => {
  return instance.post("/prescriptionRegistration", data);
};
// 問診回答登録
export const setMedicalQuestionnaireAnswer = (data) => {
  return instance.post("/medicalQuestionnaireAnswer", data);
};
// 処方箋会計API
export const setMedicalAccounting = (data) => {
  return instance.post("/medicalAccounting", data);
};
// 受取薬履歴情報取得
export const getReceiptHistory = (data) => {
  return instance.get("/getReceiptHistory", {
    params: data,
  });
};
// 現場所取得
export const getCurrentPosition = () => {
  let latitude = "";
  let longitude = "";
  let prefecture = "東京都";

  navigator.geolocation.getCurrentPosition(
    (position) => {
      latitude = position.coords.latitude;
      longitude = position.coords.longitude;
      const url = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;
      axios
        .get(url)
        .then((response) => {
          const responseDisplayName = response.data.display_name;
          const match = responseDisplayName.match(
            /[\u4e00-\u9fa5]+[都道府県]/g
          );
          prefecture = match && match[match.length - 1];
        })
        .catch((error) => {
          console.error(error);
        });
    },
    (error) => {
      console.error(error);
    }
  );
  return prefecture;
};
// クレジットカード過去利用情報取得
export const getPastPaymentCard = (data) => {
  return instance.post("/getPastPaymentCard", data);
};
// 再依頼情報取得API
export const getReregistrationInfo = (data) => {
  return instance.get("/getReregistrationInfo", { params: data });
};
// 一時保存写真を削除するAPI
export const removeTemporaryPhoto = (data) => {
  return instance.post("/removeTemporaryPhoto", data);
};
// 保険証処方箋の写真アップロードAPI
export const putInsurancePrescriptionPhoto = (data) => {
  return instance.post("/putInsurancePrescriptionPhoto", data);
};
// 保険証再登録API
export const insuranceRegistration = (data) => {
  return instance.post("/insuranceRegistration", data);
};
// 処方箋写真の例取得API
export const getPrescriptionPhotoSample = (data) => {
  return instance.get("/getPrescriptionPhotoSample", data);
};
// 保険証月度登録Api
export const getInsuranceInfo = (data) => {
  return instance.post("/getInsuranceInfo", data);
};
// 操作ログ出力API
export const setOperationLogOutput = (data) => {
  return instance.post("/operationLogOutputLine", data);
};
// 決済開始API;
export const postPaymentStart = (data) => {
  return instance2.post("/postPaymentStart", data);
};
